import { DING_THROTTLE_MS } from './workspaceUnreadUtils';

export function beginDingAttempt({
  now,
  lastDingAt = 0,
  bypassThrottle = false,
  throttleMs = DING_THROTTLE_MS
}) {
  if (bypassThrottle) {
    return { allowed: true, nextLastDingAt: lastDingAt };
  }

  if (now - lastDingAt < throttleMs) {
    return { allowed: false, nextLastDingAt: lastDingAt };
  }

  return { allowed: true, nextLastDingAt: now };
}
